<template>
        
            <LocalTable :model="model" modelLinesProp='attachmentsWorkorder' ref="attachmentsWorkorder" no-hover dense :dt="tblLines">
                <template v-slot:menu ="{ item }">
                    <ActionMenuItem icon="file" :model="model" @click="()=>onOpenAttachment(item)">Toon bijlage</ActionMenuItem>
                    <v-divider></v-divider>
                    <ActionMenuItem v-if="bool.isNotTrue(item.visible_in_app)" icon="show" :model="model" @click="()=>onSetVisibleInApp(item, true)">Toon in buitendienst app</ActionMenuItem>
                    <ActionMenuItem v-else icon="hide" :model="model" @click="()=>onSetVisibleInApp(item, false)">Verberg in buitendienst app</ActionMenuItem>
                    <v-divider></v-divider>
                    <ActionMenuItem icon="edit" :model="model" @click="()=>onRename(item)">Naam wijzigen</ActionMenuItem>
                    <v-divider></v-divider>
                    <ActionMenuItem :model="model" action="workorder.modify" icon="remove" @click="tblLines.onStartCheckBox(item, 'remove')">Verwijder bijlage</ActionMenuItem>
                </template>
                <template v-slot:commands ="{dt, bulkAction, selectedCount}">
                    <ActionButton main primary icon="remove" v-if="dt.bulkAction=='remove'"  @click="()=>onBulkRemoveAttachments()" :disabled="!dt.selectedCount" >Verwijder</ActionButton>
                </template>

                <template v-slot:tfoot="{/*dt, hasCmd, */columnHeaders}">
                <tfoot >
                    <tr>
                        <td class="pt-4 pb-4 pl-4" :colspan="columnHeaders.length+1">
                            <span class="position-absolute">
                                <ActionButton sub action="workorder.modify" dusk="btn-add-line" :model="model" icon="add" @click='(evt)=>addAttachment(evt)'>Voeg bijlage toe</ActionButton>
                            </span>
                            <span class="min-h-16"></span>
                        </td>
                    </tr>
                    
                    </tfoot>
                </template>
                
                <template v-slot:item.filename ="{ item }">
                    <span class="cursor-pointer text-primary" @click="()=>onOpenAttachment(item)">
                        {{item.filename}}
                    </span>
                </template>

            </LocalTable>
</template>



<script setup>

import ActionButton from '@shared/ui/controls/buttons/ActionButton'
import LocalTable from '@datatable/LocalTable'  
import clsLocalTable from '@cls/clsLocalTable'
import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
import {ref} from 'vue'
import StatusChip from "@controls/widgets/StatusChip.vue";
import IconMenu from "@controls/menu/IconMenu.vue";
import bool from '@lib/bool'

import dlg from '@app/dlg'

import noty from '@shared/lib/noty'

const props = defineProps({
    model: {
        type: [Object]
    },
});
let headers = [

    { canhide: false, canmove: false, type: 'cmd'}, 
    { text: "Bijlage",          value: "filename",     class: "", }, 
    { text: "Zichtbaar in App", value: "visible_in_app",    type: 'bool', class: "", }, 
    { text: "Aangemaakt door",  value: "created_by",   class: "", }, 
    { text: "Aangemaakt op",    value: "created_at",   class: "", }, 

];


let tblLines = ref(new clsLocalTable("workorder.attachmentsWorkorder", headers, {
    noDataText: "Er zijn geen bijlagen toegevoegd",
    noSort: true,
    model: props.model, 
    modelLinesProp: 'attachmentsWorkorder',    
}));

async function addAttachment(){
    try {
        var fnUpload = async function(formData) {
            
            await props.model.uploadWorkorderAttachment(formData);
        };
        dlg.upload({fnUpload: fnUpload})
//        var dt = props.model.target_at;
//        var estimate = props.model.estimate;
//
//        let selected = await dlg.promised.create("workorder_createappointment", {dt:dt, estimate:estimate});
//        props.model.createAppointment(selected)
    }
    catch (e) { /* canceled */}
}

function onBulkRemoveAttachments(line) {
    var ids = tblLines.value.selectedIDs(); 
    props.model.removeAttachments(ids);
}


function onSetVisibleInApp(line, bPublic) {
    props.model.setAttachmentVisibleInApp(line.id, bPublic);
}

async function onRename(line) {

    var name = await noty.prompt(
        "Naam:",
        "Naam wijzigen",
        line.filename,
    );
    props.model.renameAttachment(line.id, name);
}


async function onOpenAttachment(line) {
    dlg.image({
        files: props.model.attachmentsWorkorder,
        selectedUrl: line.url,
    });
}

</script>